import React = require('react');
import { useEffect, useState } from 'react';
import { toastr } from 'react-redux-toastr';
import { ITraveller } from '../../data/api/models';
import AddPaymentCardModal from '../AddPaymentCard/components/AddPaymentCardModal';
import { IPaymentMethodActions } from '../../services/paymentMethod/models';
import AddPaymentCardTransactionModal from '../AddPaymentCard/components/AddPaymentCardTransactionModal';
import { isEmpty } from 'lodash';


interface IUpdateExpiredCardProps {
  policyId: string;
  expiredPaymentId: string;
  travellers: ITraveller[];
  customerId: string;
  actions: IPaymentMethodActions;
  cardUpdated: () => any;
  policyNumber: string;
  showModal: boolean;
  updateCloseModal: () => any;
}

export const UpdateExpiredCard = ({
                                    policyId,
                                    expiredPaymentId,
                                    travellers,
                                    customerId,
                                    actions,
                                    cardUpdated,
                                    policyNumber,
                                    showModal = false,
                                    updateCloseModal,
                                  }: IUpdateExpiredCardProps) => {

  if (!expiredPaymentId && isEmpty(travellers) && !showModal) {
    return null;
  }

  const [showCardTransactionModal, setShowCardTransactionModal] = useState(false);
  const [showUpdateCardModal, setShowUpdateCardModal] = useState(false);
  const [transactionId, setTransactionId] = useState('');

  useEffect(() => {
    if (showModal) {
      setShowUpdateCardModal(true);
    }
  }, [showModal]);

  const closeCardModal = () => {
    setShowUpdateCardModal(false)
    updateCloseModal()
  }

  const openCardTransactionModal = (transactionId: string) => {
    setShowCardTransactionModal(true)
    setTransactionId(transactionId)
  }

  const closeCardTransactionModal = () => {
    setShowCardTransactionModal(false)
    setShowUpdateCardModal(false)
  }

  const assignCardToPolicy = (policyId: string, customerPaymentMethodId: string) => {
    actions.assignCardToPolicy(customerId, policyId, customerPaymentMethodId, (success) => {
      if (success) {
        toastr.success('Card assigned successfully');
        cardUpdated()
      } else {
        toastr.error('Failed to assign card')
      }
    });
  }

  return (
    <>
      <AddPaymentCardModal
        show={showUpdateCardModal}
        closeModal={closeCardModal}
        openCardTransactionModal={openCardTransactionModal}
        permissions={true}
        leadTraveller={travellers[0]}
        isMta={false}
        travellers={travellers}
        customerId={customerId}
        policyId={policyId}
        policyNumber={policyNumber}
      />

      <AddPaymentCardTransactionModal
        show={showCardTransactionModal}
        closeModal={closeCardTransactionModal}
        transactionId={transactionId}
        policyId={policyId}
        policyNumber={policyNumber}
        assignCardToPolicy={assignCardToPolicy}
      />
    </>
  );
}
